import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-12 md:py-16 bg-background-50" id="faq">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950">자주 묻는 질문 (FAQ)</h2>
          <a href="/board" className="text-xs text-primary-500 hover:text-primary-600 flex items-center gap-1">
            더보기
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((item, idx) => (
            <div
              key={item.question}
              className="faq-item bg-white rounded-lg border border-background-200 overflow-hidden opacity-0 translate-y-4"
              style={{
                animation: `faqFadeIn 0.5s ease-out ${idx * 0.1}s forwards`,
              }}
            >
              <button
                className="w-full flex items-center justify-between p-4 text-left hover:bg-background-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-sm font-medium text-foreground-950 pr-2">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 flex-shrink-0 transition-transform ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === idx ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 pb-4">
                  <p className="text-xs text-foreground-600 leading-relaxed border-t border-background-200 pt-3">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes faqFadeIn {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}